import { gql } from "@apollo/client";

export const GET_PRODUCTS_HEADER = gql`
  query getProductsHeader {
    page(id: "cG9zdDo0MDYy", idType: ID) {
      pageHeaderBlock {
        pageTitle
        pageDescription
        pageBackground {
          sourceUrl
          srcSet
        }
      }
    }
  }
`;
